import { memo, useCallback, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { Flex, Layout } from 'antd';

import { useViewerEmail } from '@/entities/viewer';

import { ReviewsModal } from '@/shared/cms/reviews';
import { getMainPath } from '@/shared/constants/router';
import { useDesktopMediaQuery, useAppSiderCollapse } from '@/shared/lib/hooks';
import { CollapsedLogo } from '@/shared/ui/logo';
import { FullSizeSkeleton } from '@/shared/ui/skeleton';

import { AppMenu } from '../../menu/app-menu/app-menu';

import cls from './app-sider.module.css';

export const AppSider = memo(() => {
    const { isCollapsed, updateCollapsedState } = useAppSiderCollapse();
    const userEmail = useViewerEmail();
    const isDesktop = useDesktopMediaQuery();

    const { pathname } = useLocation();

    const onChangeCollapse = useCallback(
        (value: boolean) => updateCollapsedState(value),
        [updateCollapsedState],
    );

    const isMainPath = useMemo(() => pathname === getMainPath(), [pathname]);

    if (!isDesktop) {
        return null;
    }

    return (
        <Layout.Sider
            className={cls.root}
            collapsed={isCollapsed}
            collapsible={!isMainPath}
            data-tour="app-menu"
            onCollapse={onChangeCollapse}
            width={220}
        >
            {isMainPath ? (
                <FullSizeSkeleton
                    className={cls.skeleton}
                    isActive
                />
            ) : (
                <Flex
                    justify="space-between"
                    style={{ height: '100%' }}
                    vertical
                >
                    <div>
                        <CollapsedLogo isCollapsed={isCollapsed} />
                        <AppMenu
                            className={cls.menu}
                            isMobile={false}
                        />
                    </div>

                    <ReviewsModal
                        isCollapsed={isCollapsed}
                        userEmail={userEmail}
                    />
                </Flex>
            )}
        </Layout.Sider>
    );
});

AppSider.displayName = 'AppSider';
